/**
 * Module dependencies.
 */

import {
  acceptLanguageHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Query` type.
 */

type Query = {
  locale: string;
  params: {
    filter?: {
      [key: string]: any;
    };
  };
};

/**
 * Export `fetchTechnologies`.
 */

export async function fetchTechnologies(query: Query) {
  const { locale, params } = query;
  const endpoint = getApiEndpoint('getTechnologies');

  try {
    const { data } = await request.get(endpoint, {
      headers: acceptLanguageHeader(locale),
      params: {
        filter: params?.filter
      }
    });

    return data?.data;
  } catch (error) {
    handleRequestError(error);
  }
}
